import React from 'react'
import { useCluster } from './hooks/useCluster'
import classes from './Cluster.module.sass'
import { Helmet } from 'react-helmet-async'
import { List } from './components/list/List'
import { Modal } from '../../../common/components/modal/Modal'
import { Details } from './components/details/Details'
import { Form } from './components/form/Form'
import Search from '../../../common/components/listControl/search/Search'
import { useSearchWithDebounce } from '../../../common/hooks/useSearchWithDebounce'
import { Stats } from './components/stats/Stats'
import { ExtendBillingForm } from './components/extendBillingForm/ExtendBillingForm'

export const Cluster = () => {
  const {
    getList,
    modalActive,
    setModalActive,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    switchCluster,
    loading,
    openPayment,
    metricsMap,
    showStats,
    statsModalActive,
    setStatsModalActive,
    detailedMetrics,
    extendModalActive,
    setExtendModalActive,
    handleOpenExtend,
  } = useCluster()

  const {
    searchQuery,
    handleSearch,
    clearSearch,
    filteredItems: filteredList,
  } = useSearchWithDebounce({
    items: list,
    searchFields: ['id', 'name', 'description', 'legalInn', 'legalName'],
  })

  return (
    <div className={classes.container}>
      <Helmet>
        <title>Справочник кластеров</title>
        <meta name="description" content="Справочник кластеров" />
      </Helmet>
      <div className={classes.header}>Справочник кластеров</div>
      <div className={classes.searchContainer}>
        <Search
          onChange={handleSearch}
          clear={clearSearch}
          value={searchQuery}
          placeHolder="Поиск по id, названию или описанию"
        />
      </div>
      <List
        showDetails={showDetails}
        startEdit={startEdit}
        list={filteredList}
        loading={loading}
        switchCluster={switchCluster}
        openPayment={openPayment}
        metricsMap={metricsMap}
        showStats={showStats}
        openExtend={handleOpenExtend}
      />
      <Modal modalActive={modalActive} setModalActive={setModalActive}>
        <Form
          edit={edit}
          data={data}
          setData={setData}
          getList={getList}
          setModalActive={setModalActive}
          el={current}
        />
      </Modal>
      <Modal modalActive={detailsModalActive} setModalActive={setDetailsModalActive}>
        <Details el={current} />
      </Modal>
      <Modal modalActive={statsModalActive} setModalActive={setStatsModalActive}>
        <Stats metrics={detailedMetrics} />
      </Modal>
      <Modal modalActive={extendModalActive} setModalActive={setExtendModalActive}>
        <ExtendBillingForm setModalActive={setExtendModalActive} cluster={current} getList={getList}/>
      </Modal>
      {/* Модалка оплаты удалена — будет в RootLayout */}
    </div>
  )
}
